module.exports = __webpack_public_path__ + "static/media/clearorb.917dd253.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/NavBar/clearorb.png
// module id = 47
// module chunks = 0